module.exports = __webpack_public_path__ + "static/media/credit_note_template.ad7c361e.docx";